// src/Components/App.jsx
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Navbar, Main, Schedule, Introductions, Success, Footer, Support, TosayobiHighSchool, NijiTaisaku } from './index';
import SupportPointHighSchool from './TosayobiHighSchool/SupportPointHighSchool';
import HighSchoolIntroduction from './TosayobiHighSchool/HighSchoolIntroduction';
import CourceHighSchool from './TosayobiHighSchool/CourceHighSchool';
import AdmissionHighSchool from './TosayobiHighSchool/AdmissionHighSchool';
import QuestionHighSchool from './TosayobiHighSchool/QuestionHighSchool';
import NavbarHighSchool from './TosayobiHighSchool/NavbarHighSchool';
import FooterHighSchool from './TosayobiHighSchool/FooterHighSchool';
import ScrollToTop from './ScrollToTop';

function App() {
  const location = useLocation();
  const isTosayobi = location.pathname.startsWith('/TosayobiHighSchool');


  return (
    <>
      {isTosayobi ? <NavbarHighSchool /> : <Navbar />}
      {/* <Navbar /> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Schedule" element={<Schedule />} />
        <Route path="/Support" element={<Support />} />
        <Route path="/Introductions" element={<Introductions />} />
        <Route path="/Success" element={<Success />} />
        <Route path="/NijiTaisaku" element={<NijiTaisaku />} />
        <Route path="/TosayobiHighSchool" element={<TosayobiHighSchool />} />
        <Route path="/TosayobiHighSchool/SupportPointHighSchool" element={<SupportPointHighSchool />} />
        <Route path="/TosayobiHighSchool/HighSchoolIntroduction" element={<HighSchoolIntroduction />} />
        <Route path="/TosayobiHighSchool/CourceHighSchool" element={<CourceHighSchool />} />
        <Route path="/TosayobiHighSchool/AdmissionHighSchool" element={<AdmissionHighSchool />} />
        <Route path="/TosayobiHighSchool/QuestionHighSchool" element={<QuestionHighSchool />} /> 
      </Routes>
      {isTosayobi ? <FooterHighSchool /> : <Footer />}
      {/* <Footer /> */}
    </>
  );
}

export default App;
